var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCieloAiLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 684.83 153.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#71f4af;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M617.51,18h-46a69.78,69.78,0,0,0,5.39,23,70.46,70.46,0,0,0,64.9,43h43V94.7H629.66a44,44,0,0,0,43.8,39.61h11.37v17.62H568.14a34.84,34.84,0,0,1-34.83-34.84V.41H650a34.84,34.84,0,0,1,34.85,34.83V67.66c-.71-2.25-1.51-4.47-2.43-6.62A70.43,70.43,0,0,0,617.51,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.44,120.77c-26,0-42.85-17.44-42.85-43.69S50.4,33.4,76.44,33.4c14.91,0,27.51,6.72,34,18.06l29-16.81c-12.81-20.78-36.33-34-63-34C32.13.63,0,33.81,0,77.08s32.13,76.44,76.44,76.44c26.88,0,50.4-13.22,63-34l-29-16.8C104.16,114.05,91.35,120.77,76.44,120.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168,.89A19,19,0,0,0,149.19,19.7a18.8,18.8,0,1,0,37.6,0A19,19,0,0,0,168,.89ZM152.32,47.7V152.16h31.34V47.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.94,98.37c0-31.56-22.57-55.17-53.08-55.17-33,0-55.58,24-55.58,55.17s22.16,55.15,57.88,55.15c19.85,0,35.31-7.32,45.56-21.52l-25.08-14.41c-4.18,4.59-11.49,7.93-20.06,7.93-11.49,0-21.11-3.76-25.08-14.62h74.18A61.19,61.19,0,0,0,306.94,98.37ZM230.88,87.5C233.8,76.84,241.74,71,253.66,71c9.39,0,18.8,4.39,22.14,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M324.7,0V152.16H356V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M429.16,43.2c-30.71,0-55.37,24-55.37,55.17s24.66,55.15,55.37,55.15,55.37-24,55.37-55.15S459.88,43.2,429.16,43.2Zm0,79.82c-13.58,0-24-9.83-24-24.65s10.44-24.67,24-24.67,24,9.83,24,24.67S442.74,123,429.16,123Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCieloAiLogo);
export default __webpack_public_path__ + "static/media/cieloAiLogo.f331d2f991dfeb81a5644d17cc97efb4.svg";
export { ForwardRef as ReactComponent };